import { Action } from 'redux';
import { isType } from 'typescript-fsa';
import { upsertValueInArrayCustomId } from 'utilities/reducer-helpers';
import * as actions from './actions';
import { UnitServiceHistoryState } from './types';

const initialState: UnitServiceHistoryState = {
	unitServiceHistories: [],
};

export function unitServiceHistoryReducer(state: UnitServiceHistoryState = initialState, action: Action): UnitServiceHistoryState {
	if (isType(action, actions.getUnitServiceHistoriesAction.done)) {
		return {
			...state,
			unitServiceHistories: action.payload.result,
		};
	}
	if (isType(action, actions.getLatestUnitServiceHistoriesAction.done)) {
		return {
			...state,
			unitServiceHistories: action.payload.result,
		};
	}
	if (isType(action, actions.createUnitServiceHistoryAction.done)) {
		return {
			...state,
			unitServiceHistories: upsertValueInArrayCustomId(state.unitServiceHistories, action.payload.result, obj => obj.id),
		};
	}

	return state;
}
